//shared containers
import { Footer } from '@/containers-m/Footer';
import { Navigation } from '/containers-m/';
import { Logos, logos_list } from '@/containers-ai/Logos';

import { Proof } from '@/containers-latam/Proof';
import { FreightExperts } from '@/containers-latam/FreightExperts';
import { LifecycleRail } from '@/containers-latam/LifecycleRail';
import { FAQ } from '@/containers-latam/FAQ';

//containers
import { Hero, EndCTA, AICompounding, Rails } from './containers/index';

//styles
import { PageWrapper, HomeGlobalStyle } from './Home.styles';

function Home({
  hero_content,
  lifecycleRail_content,
  platformScale_content,
  endCta_content,
  freightExperts_content,
  aiCompounding_content,
  proof_content,
  rails_content,
  faq_content,
  lifecycleFixedStage,
  lifecycleCaps,
  lifecycleShowProductTag,
  numberLocale,
  nav,
  footer,
}) {
  return (
    <PageWrapper>
      <HomeGlobalStyle />
      <Navigation theme="dark" nav={nav} />
      <Hero content={hero_content} />
      <Logos logos={logos_list} label={false} />
      <LifecycleRail
        content={lifecycleRail_content}
        platformScaleContent={platformScale_content}
        fixedStage={lifecycleFixedStage}
        caps={lifecycleCaps}
        showProductTag={lifecycleShowProductTag}
      />
      <EndCTA variant="top" content={endCta_content} />
      <FreightExperts content={freightExperts_content} />
      <AICompounding content={aiCompounding_content} />
      <Proof
        outcomes={proof_content.outcomes}
        kicker={proof_content.kicker}
        title={proof_content.title}
        locale={numberLocale}
      />
      <Rails content={rails_content} />
      {faq_content && <FAQ content={faq_content} />}
      <EndCTA variant="bottom" content={endCta_content} />
      <Footer config={footer} />
    </PageWrapper>
  );
}

export default Home;
export { Home };
